import { Exercise } from "../../models/Exercise";
import { Language } from "../../models/Language";
import {
  LearningPath,
  LearningPathProgresses,
  LearningPathRequest,
} from "../../models/LearningPath";
import { Lesson } from "../../models/Lesson";
import { Paged } from "../../models/Paged";
import { Quiz } from "../../models/Quiz";
import { StudentTableItem } from "../../models/StudentTableItem";
import { slavtHTTP } from "../http";

// Teacher

export function getLearningPaths(page: number) {
  return slavtHTTP
    .get<Paged<LearningPath>>(`teachers/me/learning-paths?page=${page}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getLearningPathDetails(learningPathId: string) {
  return slavtHTTP
    .get<LearningPath>(`/learning-paths/${learningPathId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getLearningPathLessons(learningPathId: string, page: number) {
  return slavtHTTP
    .get<Paged<Lesson>>(
      `/learning-paths/${learningPathId}/lessons?page=${page}`,
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getLearningPathLessonExams(
  learningPathId: string,
  lessonId: string,
  page: number,
) {
  return slavtHTTP
    .get<Paged<Exercise>>(
      `/learning-paths/${learningPathId}/lessons/${lessonId}/exams?page=${page}`,
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getLearningPathLessonQuizzes(
  learningPathId: string,
  lessonId: string,
  page: number,
) {
  return slavtHTTP
    .get<Paged<Quiz>>(
      `/learning-paths/${learningPathId}/lessons/${lessonId}/quizzes?page=${page}`,
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function createLearningPath(learningPath: LearningPathRequest) {
  return slavtHTTP
    .post<{ id: number }>("/teachers/me/learning-paths", learningPath)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function editLearningPath(learningPath: LearningPathRequest) {
  return slavtHTTP
    .patch<{ id: number }>(`/learning-paths/${learningPath.id}`, learningPath)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function deleteLearningPath(learningPathId: string) {
  return slavtHTTP
    .delete<void>(`/learning-paths/${learningPathId}`)
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getLearningPathProfessorProgresses(
  learningPathId: string,
  page: number,
) {
  return slavtHTTP
    .get<Paged<StudentTableItem>>(
      `/teachers/me/learning-paths/${learningPathId}/progresses?page=${page}`,
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

// Student

export function getStudentLearningPaths() {
  return slavtHTTP
    .get<Paged<LearningPath>>("/students/me/learning-paths", {})
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getStudentLearningProgresses(learningPathId: string) {
  return slavtHTTP
    .get<LearningPathProgresses>(
      `/students/me/learning-paths/${learningPathId}/progresses`,
      {},
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getLanguages() {
  return slavtHTTP
    .get<Paged<Language>>(`/languages`, {})
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function getTeacherLanguages() {
  return slavtHTTP
    .get<Paged<Language>>(`teachers/me/languages`, {})
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
